import { render, staticRenderFns } from "./transactions-card.vue?vue&type=template&id=5f231ab1&scoped=true&"
import script from "./transactions-card.vue?vue&type=script&lang=js&"
export * from "./transactions-card.vue?vue&type=script&lang=js&"
import style0 from "./transactions-card.vue?vue&type=style&index=0&id=5f231ab1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f231ab1",
  null
  
)

export default component.exports